import { ReportCategory } from "../enums/Reports";
import { Status } from "../enums/Status";
export type TcfdRequestParams = {
  pPortfolio: string;
  pIndex: string;
};
export type StewardshipParams = {
  pManager: string;
  pBenchmark: string;
};

export type StewardshipCodeParams = {
  pBenchmark: string;
};

export type EngagementParams = {
  pManager: string;
};

export type DefaultRequestParams = {
  default: string;
};

export type ReportRequestParams =
  | TcfdRequestParams
  | DefaultRequestParams
  | Record<string, string | number>;

export type StringParams = {
  StringParameters: ReportRequestParams;
};

export type CreateReportParams = {
  Parameters: StringParams;
  Report: ReportCategory;
};

export type ReportJobStartedConfig = {
  SnapshotJobId: string;
  DashboardId: string;
};

export type CreateReportResponse = {
  status: Status;
  message: string;
  data?: ReportJobStartedConfig;
};

export type ReportJobStatus = {
  Status: string;
  Url: string | null;
};

export type ReportJobStatusResponse = {
  status: Status;
  message: string;
  data?: ReportJobStatus;
};

export enum ReportStatuses {
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}
